import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UtilsPipeModule } from 'mbs-ui-shared@utils/utils.pipe.module';

@NgModule({
  imports: [CommonModule, UtilsPipeModule],
  exports: [UtilsPipeModule]
})
export class UtilsModule {}
